// URL of the gallery manifest.json published by the admin app.
// Example: https://<storage-account>.blob.core.windows.net/submission-images/manifest.json
export const GALLERY_MANIFEST_URL = process.env.REACT_APP_GALLERY_MANIFEST_URL || '';
